export default "__VITE_ASSET__DWXsjYMd__"